import { CommonModule } from "@angular/common";
import { Component, inject, output } from "@angular/core";
import { BaseConfig } from "../common/config/config.adapter";
import { Icon } from "../icon/icon.component";
import { Capacitor } from "@capacitor/core";
import { ModalService } from "../../services/service";

@Component({
    selector: "app-modal-header",
    template: `
        <section
            [class.safe-top]="platform === 'ios'"
            class="z-10 flex justify-between w-full p-4 border-b theme-border bg-white"
        >
            <div class="flex gap-3 items-center *:font-semibold lg:text-lg">
                <div class="flex lg:hidden items-center">
                    <app-icon
                        (click)="close()"
                        name="material-symbols:arrow-back-ios-new"
                        class="cursor-pointer text-gray-700"
                        size="sm"
                    />
                </div>
                <ng-content />
            </div>
            <div class="flex items-center gap-3">
                <ng-content select="[buttons]" />
                <div class="lg:flex hidden items-center justify-center">
                    <app-icon
                        (click)="close()"
                        name="mdi:close"
                        class="cursor-pointer text-gray-700"
                    />
                </div>
                <ng-content select="[icons]" />
            </div>
        </section>
    `,
    imports: [Icon, CommonModule],
    styles: `
        .safe-top {
            padding-top: constant(safe-area-inset-top);
            padding-top: env(safe-area-inset-top);
        }
    `,
})
export class ModalHeader extends BaseConfig {
    readonly modalService = inject(ModalService);
    platform = Capacitor.getPlatform();
    closeEmitter = output<void>({ alias: "close" });

    close() {
        this.modalService.close();
    }
}
